<!--  -->
<template>
  <div class="container">
    <div class="pic1-panel" v-show="activePage === 0">
      <div class="left-panel">
        <img src="../../../../assets/images/img_p2_1_phone.png" alt="截图">
      </div>
      <div class="right-panel">
        <h3>线上互动，高效诊疗</h3>
        <div class="desc-wrapper">
          <p>Dr默，为医生和患者搭建便捷的咨询交流平台。同时也为产科医生提供了一个提高诊疗技术、促进分享交流的平台。<a href="http://og.gzmoninet.com/website/og/index.html"><span>查看详情<img  src="../../../../assets/images/btn_double_arrow_pink.png"></span></a></p>
        </div>
        <div class="qrcode-wrapper">
          <div>
            <img src="../../../../assets/images/drmocode.png" alt="孕e家二维码">
            <p>扫一扫 马上下载</p>
          </div>
        </div>
      </div>
    </div>
    <div class="pic2-panel" v-show="activePage === 1">
      <div class="text-panel">
        <h3>健康咨询</h3>
        <p>在线回答患者的提问，最大化利用医生碎片化时间，增加优质医疗资源的利用率。</p>
      </div>
      <div class="pic-panel">
        <img src="../../../../assets/images/img_p2_2_pic.png" alt="">
      </div>
    </div>
    <div class="pic2-panel" v-show="activePage === 2">
      <div class="pic-panel">
        <img src="../../../../assets/images/img_p2_3_pic.png" alt="">
      </div>
      <div class="text-panel">
        <h3>精品视频</h3>
        <p>产科大咖网上视频教学。让你及时了解最新的临床指南，学习最新的诊疗技术，不断提高医疗水平。（敬请期待）</p>
      </div>
    </div>
    <div class="pic2-panel" v-show="activePage === 3">
      <div class="text-panel">
        <h3>学术会议</h3>
        <p>全国产科大型学术会议报道，重要会议的在线直播互动，随时提问，解答疑惑。(敬请期待）</p>
      </div>
      <div class="pic-panel">
        <img src="../../../../assets/images/img_p2_4_pic.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      activePage: 0
    }
  },

  props: [],

  watch: {},

  components: {},

  computed: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
.container {
  width: 100%;
  .pic1-panel {
    padding: 0 410px;
    display: flex;
    justify-content: space-between;
    .right-panel {
     display: inline-block;
     vertical-align: top;
     width: 600px;
     margin-top: 11vh;
     h3 {color: #FF789E; font-size: 30px; line-height: 42px; font-weight: 600; text-align: left; margin-bottom: 13px;}
     .desc-wrapper {
       width:550px;
       p {
         color: #666; font-size: 18px; line-height: 30px; text-align: left;
         a {cursor: pointer;float: right; }
         a:hover {font-weight: 600;text-decoration: none;}
         }
       span { 
         color: #FF789E; font-size: 18px; line-height: 30px;
         display: flex; align-items: center;
         img {margin-left: 2px; width: 18px; height: 18px; }
       }
     }
     .qrcode-wrapper {
        margin: 5vh 0  0 173px;
        text-align: left;
        div {
          width: 204px;
          height: 204px;
          img {
            width: 100%;
            height: 100%;
          }
          p {text-align: center; font-size: 24px; line-height: 33px; color:#FF789E; font-weight: 600;}
        }
     }
    }
    .left-panel {
       display: inline-block;
       vertical-align: top;
       width: 420px;
       height: 660px;
       img {
        width: 100%;
        height: 100%;
       }
    }
  }

  .pic2-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    padding: 0 380px;
    height: 100%;
    margin-top: 50px\0;
    .text-panel {
      display: inline-block;
      vertical-align: middle;
      width: 460px;
      text-align: left;
      h3 { color: #FF789E; font-size: 30px; line-height: 42px; font-weight: 600; margin-bottom: 17px;}
      p {color: #666; font-size: 24px; line-height: 38px;}
    }
    .pic-panel {
      display: inline-block;
      vertical-align: middle;;
      width: 610px;
      height: 540px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/productBox/og.vue